module.exports = __webpack_public_path__ + "img/DAY1-2.c6752f37.jpg";